<div id="error-404" fxLayout="column" fxLayoutAlign="center center">

    <div class="content" fxLayout="column" fxLayoutAlign="center center">

        <div class="error-code">404</div>

        <div class="message mb-24">{{ 'errors.ErrPageNotFound' | translate }}</div>

        <button mat-button color="accent" style="margin-top: 5px;" (click)="back()">{{ 'LABELS.BACK' | translate }}</button>
        <button mat-button color="accent" style="margin-top: 5px;" (click)="logout()">{{ 'LABELS.LOGOUT' | translate }}</button>
        
    </div>

</div>